import getSettings from './getSettings';
import updateSettings from './updateSettings';
import resetUpdateSettingsStatusLoading from './resetUpdateSettingsStatusLoading';
import getAutosCoordinates from './getAutosCoordinates';
import setAutosCoordinates from './setAutosCoordinates';
import setAutosCoordinatesStatusLoading from './setAutosCoordinatesStatusLoading';
import resetAutosCoordinates from './resetAutosCoordinates';
import { getUserCurrentLocation } from './getUserCurrentLocation';
import resetUserCurentLocation from './resetUserCurentLocation';
import getUserCards from './getUserCards';
import getHistoryUserLocation from './getHistoryUserLocation';
import resetHistoryUserLocation from './resetHistoryUserLocation';
import setUserGeoPosition from './setUserGeoPosition';
import resetUserGeoPosition from './resetUserGeoPosition';
import setUserGeoPositionStatusLoading from './setUserGeoPositionStatusLoading';

const operations = {
  getSettings,
  updateSettings,
  resetUpdateSettingsStatusLoading,
  getAutosCoordinates,
  setAutosCoordinates,
  setAutosCoordinatesStatusLoading,
  resetAutosCoordinates,
  getUserCurrentLocation,
  resetUserCurentLocation,
  getUserCards,
  getHistoryUserLocation,
  resetHistoryUserLocation,
  setUserGeoPosition,
  resetUserGeoPosition,
  setUserGeoPositionStatusLoading,
};

export default operations;
